module.exports = __webpack_public_path__ + "static/img/address-nodata.eaea64d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new-user/address-nodata.png
// module id = y5+2
// module chunks = 4